// extracted by mini-css-extract-plugin
export default {"faqsHead":"styles_faqsHead__3fr8S","cardBody":"styles_cardBody__EwAQm","items":"styles_items__yHEyi"};